import * as React from 'react';
import { useFragment } from 'react-relay';
import { QuoteBorder } from '../quoteBlock';
import { logoBlockFragment } from './LogoBlock.relay';
import { getLogoBlockClassName } from './lib/LogoBlockStyles';
import type { LogoBlockPropsType } from './types';

const LogoBlock: React.FC<LogoBlockPropsType> = ( props: LogoBlockPropsType ) => {
    const contentBlock = useFragment( logoBlockFragment, props.contentBlock );

    return (
        <div className={getLogoBlockClassName(props.extraProps.logoBlockCount % 2 !== 1)}>
            <div className='image-wrapper'>
                <img src={ contentBlock.logoUrl } alt={ contentBlock.logoAltText } />
            </div>
            <div className='caption-wrapper'>
                <div>
                    <QuoteBorder borderOnly={ !contentBlock.isQuote } />
                    <h2>{contentBlock.captionTitle}</h2>
                    <p>{contentBlock.captionText}</p>
                    <QuoteBorder closing borderOnly={ !contentBlock.isQuote } />
                </div>
            </div>
        </div>
    );
};

export { LogoBlock };
